import { Box, Typography } from "@mui/material";

interface ChatContactProps {
  message: string;
  tag?: string;
}

export const ChatContact: React.FC<ChatContactProps> = ({ message, tag }) => {
  return (
    <Box
      display="flex"
      alignItems="start"
      flexDirection="column"
      gap={1}
    >
      {tag && <Typography variant="body2" color="text.secondary">{tag}</Typography>}
      <Typography
        variant="body2"
        component="div"
        whiteSpace="pre-line"
      >
        {message}
      </Typography>
    </Box>
  );
};
